import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.script');
import { OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-script',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.script/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.script-content blockquote {
  margin: 1rem 0;
}
.script-content p {
  margin-bottom: 1rem;
}
.script-content p:last-child {
  margin-bottom: 0;
}`],
})
export class PageScriptComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('contentArea') contentArea: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public sections: any[] = [];
    public activeSection: number = 0;
    public loaded: boolean = false;

    private observer: IntersectionObserver;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngAfterViewInit() {
        this.setupObserver();
    }

    public ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private async load() {
        let { code, data } = await wiz.call("load");
        if (code == 200) {
            this.sections = data.sections || [];
            this.loaded = true;
            await this.service.render();
            setTimeout(() => this.setupObserver(), 100);
        }
    }

    private setupObserver() {
        if (this.observer) this.observer.disconnect();
        if (!this.contentArea) return;

        const container = this.contentArea.nativeElement;
        const sectionEls = container.querySelectorAll('[data-section]');
        if (!sectionEls.length) return;

        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        const idx = parseInt(entry.target.getAttribute('data-section') || '0');
                        if (idx !== this.activeSection) {
                            this.activeSection = idx;
                            this.service.render();
                        }
                        break;
                    }
                }
            },
            {
                root: container,
                rootMargin: '-10% 0px -80% 0px',
                threshold: 0
            }
        );

        sectionEls.forEach((el: Element) => this.observer.observe(el));
    }

    public scrollTo(index: number) {
        this.activeSection = index;
        const el = document.querySelector(`[data-section="${index}"]`);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.service.render();
    }

    public goBack() {
        this.service.href('/hub');
    }

    public isInteractive(title: string): boolean {
        return title.includes('인터랙티브') || /슬라이드 (8|9|13|14) /.test(title);
    }

    public getSlideNumber(title: string): string {
        const match = title.match(/슬라이드 (\d+)/);
        return match ? match[1] : '';
    }

    public getSlideTitle(title: string): string {
        const match = title.match(/— (.+)$/);
        return match ? match[1] : title;
    }

    public formatContent(content: string): string {
        if (!content) return '';
        let html = content;

        // 화면 지시문: **[화면: ...]**
        html = html.replace(/\*\*\[화면:([^\]]+)\]\*\*/g,
            '<div class="bg-amber-50 border-l-4 border-amber-400 p-4 text-[13px] text-amber-800 rounded-r-lg my-4"><span class="font-medium">화면:</span>$1</div>');

        // 조작 안내: > 💡 *조작 안내: ...*
        html = html.replace(/> 💡 \*조작 안내:([^*]+)\*/g,
            '<div class="bg-blue-50 border-l-4 border-blue-400 p-4 text-[13px] text-blue-800 rounded-r-lg my-4"><span class="font-medium">💡 조작 안내:</span>$1</div>');

        // 인용문: > ...
        html = html.replace(/^> (.+)$/gm,
            '<blockquote class="border-l-4 border-gray-300 pl-4 text-gray-600 italic my-4">$1</blockquote>');

        // 볼드: **...**
        html = html.replace(/\*\*([^*]+)\*\*/g, '<strong class="font-semibold text-gray-900">$1</strong>');

        // 이탤릭 (남은): *...*
        html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');

        // 구분선: ---
        html = html.replace(/^---$/gm, '<hr class="border-gray-200 my-6">');

        // 단락 처리
        html = html
            .split('\n\n')
            .map((p: string) => {
                p = p.trim();
                if (!p) return '';
                if (p.startsWith('<div') || p.startsWith('<blockquote') || p.startsWith('<hr')) return p;
                return `<p class="mb-4">${p.replace(/\n/g, '<br>')}</p>`;
            })
            .join('\n');

        return html;
    }
}

export default PageScriptComponent;